import { BoxLogBloc } from "./bloc.box";
import { CloudLogBloc } from "./bloc.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseLogBloc } from "./bloc.base";
import environment from "@/config";

export default getService<BaseLogBloc>(environment.nexus, {
    box: new BoxLogBloc(),
    cloud: new CloudLogBloc(),
    demo: new CloudLogBloc(),
});